module.exports = __webpack_public_path__ + "media/images/emblems/Untereggen.sg-e5f1f37ae827e0b3b2afc32c171084a0.png";